import PropTypes from "prop-types";
import React from "react";
import { Modal, ModalBody, ModalFooter } from "reactstrap";

const CancelModal = ({ show, onCancelClick, onCloseClick, isCancelling }) => {
  return (
      <Modal isOpen={show} toggle={onCloseClick} centered={true}>
        <ModalBody className="py-3 px-5">
          <div className="mt-2 text-center">
            <lord-icon
                src="https://cdn.lordicon.com/nqtddedc.json"
                trigger="loop"
                colors="primary:#f7b84b,secondary:#f06548"
                style={{ width: "100px", height: "100px" }}
            ></lord-icon>
            <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
              <h4>Cancel Invoice?</h4>
              <p className="text-muted mx-4 mb-0">
                Are you sure you want to cancel this invoice? This action cannot be undone and will mark the invoice as canceled.
              </p>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
              className="btn btn-light"
              onClick={onCloseClick}
              disabled={isCancelling}
          >
            Keep Invoice
          </button>
          <button
              className="btn btn-warning"
              onClick={onCancelClick}
              disabled={isCancelling}
          >
            {isCancelling ? 'Canceling...' : 'Cancel Invoice'}
          </button>
        </ModalFooter>
      </Modal>
  );
};

CancelModal.propTypes = {
  onCloseClick: PropTypes.func,
  onCancelClick: PropTypes.func,
  show: PropTypes.any,
  isCancelling: PropTypes.bool
};

export default CancelModal;